// removed by extract-text-webpack-plugin
module.exports = {"container":"post__container___12HdB","fadein":"post__fadein___3AbBq","header":"post__header___MNJhs","publishedAt":"post__publishedAt___12rHj","title":"post__title___15a48","cover":"post__cover___3lxkI","backBtn":"post__backBtn___3ULfn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/post/post.scss
// module id = 403
// module chunks = 0